import LiveMonitor from "../components/live_monitor/LiveMonitor";

function LiveMonitorPage() {
    return (
        <div className="min-h-screen bg-surfaceSoft p-10">
            <div className="mb-8">
                <p className="text-sm uppercase tracking-[4px] text-electricBlue font-semibold">
                    Operations Center
                </p>

                <h1 className="mt-2 text-3xl md:text-4xl font-bold text-textPrimary">
                    Live Monitor
                </h1>

                <p className="text-sm md:text-base mt-2 text-textSecondary">
                    Real-time monitoring of generators and power distribution equipment.
                </p>
            </div>

            <LiveMonitor />
        </div>
    )
}

export default LiveMonitorPage;